import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import Moveable from 'react-moveable';
import Selecto from 'react-selecto';
import PropTypes from 'prop-types';
import * as utils from './util';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import { useSelector, useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import ResizeObserver from 'resize-observer-polyfill';
import isMobile from 'is-mobile';
import './VMoveable.css';

const VMoveable = props => {
  const dispatch = useDispatch();
  const editableTextId = useSelector(state => state.design.enabledEditorId);
  const entityEditableMode = useSelector(state => state.design.entityEditableMode);
  const artboarWidth = useSelector(state => state.design.width);
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const pages = useSelector(state => state.design.pages);
  const entitiesState = useSelector(state => state.design.entitiesState);
  const pageScale = useSelector(state => state.design.scale);
  const { activePageRef } = useContext(DesignContext);
  const [targetConfig, setTargetConfig] = useState(null);
  const [targets, setTargets] = useState([]);
  const [isShift, setIsShift] = useState();
  const [lastPos, setLastPos] = useState();
  const [cropTarget, setCropTarget] = useState(null);
  const [keys, setKeys] = useState({ isShift: false, isCtrl: false });
  const [entitiesList, setEntitiesList] = useState(null);
  const [windowHight, setWindowHight] = useState(null);
  const [elementGuidelines, setElementGuidelines] = useState([]);
  const mobile = false; //isMobile();

  const selectoRef = useRef(null);
  const moveableRef = useRef(null);
  const cropMoveableRef = useRef(null);
  let saveTimeout;

  useEffect(() => {
    //movLog('targets changed', 'targets', targets);
  }, [targets]);
  useEffect(() => {
    //movLog('selectedEntity changed', 'selectedEntity', selectedEntity);
  }, [selectedEntity]);
  // Add moveable elements to holder and set listeners
  useEffect(() => {
    // //movLog('Moveable reload');
    ReactDOM.render(SelectoC(), document.getElementById('selectoHolder'));
    if (!mobile) {
      document.addEventListener('keydown', onKeyDown);
      document.addEventListener('keyup', onKeyUp);
    } else {
      const rSable = document.querySelectorAll('.rSable');
      // //movLog('', 'rSable', rSable);
      if (rSable) {
        Array.from(rSable).forEach(function (element) {
          element.addEventListener('mouseup', onMouseup, true);
        });
      }
    }
    const mainHolder = document.getElementById('artboardHolder');
    mainHolder.addEventListener('scroll', onScroll);
    numbersCheck();
    return () => {
      mainHolder.removeEventListener('scroll', onScroll);
      if (!mobile) {
        document.removeEventListener('keydown', onKeyDown);
        document.removeEventListener('keyup', onKeyUp);
      } else {
        const rSable = document.querySelectorAll('.rSable');
        // //movLog('', 'rSable', rSable);
        if (rSable) {
          Array.from(rSable).forEach(function (element) {
            element.removeEventListener('mouseup', onMouseup, true);
          });
        }
      }
    };
  });

  // Blur artBoard until load complete
  useEffect(() => {
    //movLog('Moveable first load');
    setTimeout(() => {
      document.getElementById('artboardHolder').classList.remove('onLoad');
    }, 2000);
    const windowSizeChanged = () => {
      //movLog('window size changed', 'windowHeight', windowHight);
      //movLog('', 'New Height', window.innerHeight);
    };
    setWindowHight(window.innerHeight);
    window.onresize = windowSizeChanged;
  }, []);

  // update moveable rect from outside changes
  useEffect(() => {
    //movLog('entitiesState change 1', 'entitiesState', entitiesState);
    //movLog('', 'selectedEntity', selectedEntity);
    const newWindowHeight = window.innerHeight;
    if (windowHight - newWindowHeight > 200) {
      document.getElementsByTagName('body')[0].classList.add('softKeyboard');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('softKeyboard');
    }
    moveableRef && moveableRef.current && moveableRef.current.updateRect();
    cropMoveableRef && cropMoveableRef.current && cropMoveableRef.current.updateRect();
    if (targets && targets.length > 1) updateGroupTargetConfig();
    if (selectedEntity && (selectedEntity.id || selectedEntity.id === 0)) {
      if (_.get(targetConfig, 'target') && _.get(targetConfig, 'id') !== selectedEntity.id) updateTargetConfig();
      if (!entitiesState) return;
      // let changeLockState = { id: selectedEntity.id, type: null };
      // if (!Array.isArray(selectedEntity.id)) {
      //   if (!entitiesState || !entitiesState[selectedEntity.id]) return;
      //   if (selectedEntity.type !== 'Locked' && entitiesState[selectedEntity.id].lock) {
      //     changeLockState.type = 'Locked';
      //   } else if (selectedEntity.type === 'Locked' && !entitiesState[selectedEntity.id].lock) {
      //     changeLockState.type = entitiesState[selectedEntity.id].type;
      //   }
      // } else {
      //   let hasLocked = false;
      //   selectedEntity.id.forEach(id => {
      //     if (entitiesState[id].lock) hasLocked = true;
      //   });
      //   if (hasLocked) changeLockState.type = 'Locked';
      // }
      // if (changeLockState.type && selectedEntity.type !== changeLockState.type) {
      //   //movLog('', 'on Select Entity 0');
      //   onSelectEntity(changeLockState);
      // }
      let lockState = false;
      if (!Array.isArray(selectedEntity.id)) {
        if (!entitiesState || !entitiesState[selectedEntity.id]) return;
        lockState = _.get(entitiesState[selectedEntity.id], 'lock', false);
      } else {
        selectedEntity.id.forEach(id => {
          if (entitiesState[id].lock) lockState = true;
        });
      }
      if (lockState && selectedEntity.lock !== lockState) {
        //movLog('', 'on Select Entity 0');
        onSelectEntity({ ...selectedEntity, lock: lockState });
      }
    }
    if (targetConfig && targetConfig.target) {
      setTimeout(() => {
        controllerUpdate(targetConfig.target, 1);
      });
    }
    const controller = document.querySelector('#selectoHolder .mainMoveable #vController');
    if (controller) {
      const controllerId = controller.dataset.id.split('_')[1];
      const controllerMainTarget = document.querySelector(`[data-target="P_${controllerId}"]`);
      const controllerMainTargetFrame = document.querySelector(`[data-target="F_${controllerId}"]`);
      const pictureVideo = controllerMainTarget && controllerMainTarget.querySelector('video');
      const frameVideo = controllerMainTargetFrame && controllerMainTargetFrame.querySelector('video');
      (!controllerMainTarget && !controllerMainTargetFrame) || (!pictureVideo && !frameVideo) && controller.remove();
    }
  }, [entitiesState, pageScale]);

  // update pages lock from outside changes
  useEffect(() => {
    //movLog('pages change', 'pages', pages);
    if (entitiesState && Object.keys(entitiesState).length !== entitiesList)
      setEntitiesList(Object.keys(entitiesState).length);
    if (selectedEntity && (selectedEntity.id || selectedEntity.id === 0)) {
      const selectEntityId = _.get(selectedEntity, 'id').toString();
      if (!selectEntityId) return;
      if (!pages || !selectEntityId.includes('-')) return;
      let selected = { id: selectedEntity.id, type: null, lock: null };
      const backgroundId = selectedEntity.id.replace('-', '');
      selected.type = `${_.get(pages[backgroundId], 'background.media.Type', '')}Background`;
      selected.lock = _.get(pages[backgroundId], 'background.lock', false);

      if (selectedEntity.type !== selected.lock) {
        //movLog('', 'on Select Entity 1');
        onSelectEntity(selected);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages]);

  // Check targetConfig
  useEffect(() => {
    //movLog('targetConfig Change', 'targetConfig', targetConfig);
    let targetArray = [];
    if (targetConfig && targetConfig.target && !Array.isArray(targetConfig)) {
      targetArray = [targetConfig.target];
      targetConfig.target.addEventListener('dblclick', dblClickHandler);
      videoController(activePageRef.current, targetConfig.target, targetConfig.id);
    } else if (targetConfig && Array.isArray(targetConfig)) {
      targetConfig.forEach(element => {
        targetArray.push(element.target);
      });
    }
    const selectedEntityId = _.get(selectedEntity, 'id');
    if (
      !_.isEqual(targetArray, targets) &&
      !Array.isArray(targetConfig) &&
      selectedEntityId === _.get(targetConfig, 'id')
    ) {
      setTargets(targetArray);
    } else if (!_.isEqual(targetArray, targets) && Array.isArray(targets)) {
      setTargets(targetArray);
    } else if (Array.isArray(targetConfig)) {
      const newTargets = [];
      targetConfig.forEach(tc => {
        newTargets.push(tc.target);
      });
      setTargets(newTargets);
    }
    //movLog('', 'targetConfig2', targetConfig);
    moveableRef && moveableRef.current && moveableRef.current.updateRect();
    cropMoveableRef && cropMoveableRef.current && cropMoveableRef.current.updateRect();
    const toolbar = document.getElementById('toolbar');
    switch (_.get(targetConfig, 'editMode')) {
      case 'crop':
        // eslint-disable-next-line no-case-declarations
        const transform = utils.getTransform(targetConfig.holderEl);
        if (!transform || !targetConfig.holderEl) {
          return;
        }
        toolbar && toolbar.append(CropBar());
        setCropTarget({
          target: targetConfig.holderEl,
          originStyle: targetConfig.holderEl.style,
          frame: {
            translate: [transform.tx, transform.ty],
            scale: [transform.sx, transform.sy],
            rotate: transform.rotate,
          },
        });
        // eslint-disable-next-line no-case-declarations
        const holderImage = _.get(targetConfig.holderEl.querySelector('img'),"src");
        const holderVideo = _.get(targetConfig.holderEl.querySelector('video'),"src");
        // eslint-disable-next-line no-case-declarations
        let imageSrc = holderImage ? holderImage : holderVideo;
        imageSrc = imageSrc?.replace('thumbnail', 'screen');
        // eslint-disable-next-line no-case-declarations
        setTimeout(() => {
          const moveableArea = document.querySelector('.moveable-area');
          if (moveableArea) {
            moveableArea.style.backgroundImage = `url("${imageSrc}")`;
            // const flipper = targetConfig.target.querySelector('.flipper');
            // const flip = flipper.style.transform.replace(/[ ,.)(]|scale/g, '');
            // moveableArea.className = `moveable-area flip${flip}`;
            // flipObserver.observe(flipper, {
            //   attributes: true,
            //   attributeFilter: ['style'],
            // });
          }
        }, 100);
        // eslint-disable-next-line no-case-declarations
        const direction = targetConfig.type === 'Image' ? ['w', 'n', 'e', 's'] : [];
        document.getElementById('artboardHolder').classList.add('onEdit');
        setTargetConfig({
          ...targetConfig,
          ables: {
            isResizable: true,
            isScalable: false,
            isRotatable: false,
            isDraggable: true,
          },
          directions: direction,
          editMode: true,
        });
        setTimeout(() => {
          cropMoveableRef && cropMoveableRef.current && cropMoveableRef.current.updateRect();
        }, 3000);
        break;
      case 'typing':
        changeParent();
        if (_.get(targetConfig, 'target')) resizeObserver.observe(targetConfig.target);
        break;
      default:
        if (!_.get(targetConfig, 'onEdit')) {
          document.getElementById('artboardHolder').classList.remove('onEdit');
          const onEditTarget = document.querySelector('.moveable.onEdit');
          if (onEditTarget) onEditTarget.classList.remove('onEdit');
          flipObserver.disconnect();
          setTimeout(() => {
            resizeObserver.disconnect();
          });
          enableEditor(-1);
          if (window.getSelection) {
            window.getSelection().removeAllRanges();
          } else if (document.selection) {
            document.selection.empty();
          }
          const cropBar = document.getElementById('cropBar');
          cropBar && cropBar.remove();
          setCropTarget(null);
          if (targetConfig && targetConfig.editMode === 'typing') changeReverse();
        }
    }
    if (targetConfig && (targetConfig.id || targetConfig.id === 0)) {
      setTimeout(() => {
        let entityType = targetConfig.type;
        let entityLock = false;
        if (targetConfig.target.dataset.lock === 'true') {
          // entityType = 'Locked';
          entityLock = true;
        }
        //movLog('', 'on Select Entity 2');
        // changeTargetConfig();
        onSelectEntity({
          id: targetConfig.id,
          type: entityType,
          lock: entityLock,
        });
      });
    }
    if (targetConfig && targetConfig.length > 1) {
      const ids = targetConfig.map(value => value.id);
      const types = targetConfig.map(value => value.type);
      const type = allEqual(types) ? `${types[0]}Group` : 'Group';
      //movLog('', 'on Select Entity 3');
      onSelectEntity({ id: ids, type: type, lock: false });
    }

    return () => {
      //movLog('targetConfig Reverse', 'targetConfig', targetConfig);
      targetConfig &&
        targetConfig.target &&
        !Array.isArray(targetConfig) &&
        targetConfig.target.removeEventListener('dblclick', dblClickHandler);
      const controller = document.querySelector('#selectoHolder .mainMoveable #vController');
      if (controller) {
        const controllerId = controller.dataset.id.split('_')[1];
        const controllerMainTarget = document.querySelector(`[data-target="P_${controllerId}"]`);
        const controllerMainTargetFrame = document.querySelector(`[data-target="F_${controllerId}"]`);
        controllerMainTarget && controllerMainTarget.appendChild(controller);
        controllerMainTargetFrame && controllerMainTargetFrame.appendChild(controller);
        !controllerMainTarget && !controllerMainTargetFrame && controller.remove();
      }
      if (_.get(targetConfig, 'editMode') === 'typing') {
        if (!targetConfig.holderEl) return;
        targetConfig.holderEl.style = '';
        targetConfig.target.appendChild(targetConfig.holderEl);
        if (targetConfig.target.dataset.notFix) {
          targetConfig.target.style.width = '';
        }
      }
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetConfig]);

  // Check selectedEntity
  useEffect(() => {
    //movLog('Check for entity(s) selected', 'entitiesList', entitiesList);
    const selectedEntityId = _.get(selectedEntity, 'id');
    const newTarget = document.getElementById(`_${selectedEntityId}_`);
    if (newTarget) selectEntities(null, newTarget);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entitiesList]);

  // Check edit mode by external changes
  useEffect(() => {
    //movLog('check edit mode by external changes', 'entityEditableMode', entityEditableMode);
    if (
      targetConfig &&
      _.get(targetConfig, 'id') === _.get(entityEditableMode, 'id') &&
      _.get(entityEditableMode, 'editable')
    )
      setTimeout(() => {
        dblClickHandler();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityEditableMode]);

  // Highlight Active Page
  useEffect(() => {
    console.log('Active Page => ', activePageRef.current);
    const pages = [...document.querySelectorAll('.artboardContainer')];
    pages.map(page => {
      page.classList.remove('activePage');
      console.log('Page => ', page);
    });
    const activePage = document.getElementById(`artboardContainer_${activePageRef.current}`);
    activePage && activePage.classList.add('activePage');
    console.log('activePage => ', activePage);
  }, [activePageRef.current]);

  // Redux methods
  const changeEditableMode = (entityId, editable) => {
    //movLog('changeEditableMode');
    dispatch(designActions.changeEditableMode({ id: entityId, editable: editable }));
  };

  const enableEditor = editorId => {
    //movLog('enableEditor');
    dispatch(designActions.enableEditor(editorId));
  };
  const showColorPicker = show => {
    //movLog('showColorPicker');
    dispatch(designActions.setSidePanel(show ? 'colorPicker' : null));
  };
  const showFilterPanel = show => {
    //movLog('showFilterPanel');
    dispatch(designActions.showFilterPanel(show));
  };

  const onEntityStyleChanged = changed => {
    //movLog('onEntityStyleChanged', 'changed', changed);
    if (!Array.isArray(changed) && !targetConfig.save) return;
    const innerDeny = ['Text', 'Frame', 'Shape', 'Vector'];
    if (changed.length > 1) {
      dispatch(designActions.changeGroupEntityStyle(activePageRef.current, changed));
    } else {
      const style =
        !changed.innerStyle || innerDeny.includes(changed.type)
          ? { master: changed.masterStyle }
          : { master: changed.masterStyle, inner: changed.innerStyle };
      if (changed.type === 'Frame' && targetConfig.onEdit) {
        const upData = {
          medias: { style: { master: changed.masterStyle, inner: changed.innerStyle } },
        };
        dispatch(designActions.changeFrameData(activePageRef.current, changed.id, upData));
      } else if (changed.type === 'Grid' && targetConfig.onEdit) {
        dispatch(designActions.changeGridData(activePageRef.current, changed.id, changed.data));
      } else {
        dispatch(designActions.changeEntityStyle(activePageRef.current, changed.id, style));
      }
    }
  };

  //Crop toolbar cover
  const CropBar = () => {
    //movLog('CropBar');
    const element = document.createElement('div');
    const confirmBtn = document.createElement('span');
    confirmBtn.className = 'btn confirmBtn';
    confirmBtn.onclick = function () {
      exitCropMode();
    };
    const cancelBtn = document.createElement('span');
    cancelBtn.className = 'btn cancelBtn';
    cancelBtn.onclick = function () {
      const cancelStyle = entitiesState[targetConfig.id];
      // targetConfig.holderEl.style = cropTarget.originStyle;
      exitCropMode(cancelStyle);
    };
    element.id = 'cropBar';
    element.append(confirmBtn);
    // element.append(cancelBtn);
    return element;
  };

  // Exit Crop Mode
  const exitCropMode = cancelStyle => {
    //movLog('Exit cropMode');
    if (cancelStyle) {
      targetConfig.target.style = cancelStyle.targetStyle;
      targetConfig.holderEl.style = cancelStyle.holderStyle;
    }
    setTargetConfig({
      ...targetConfig,
      editMode: '',
      onEdit: false,
    });
  };
  // Moveable log
  const movLog = (title, text, parameter) => {
    // return;
    if (title) console.log(`______________ ${title} ______________`);
    if (text) console.log(`${text} -> `, parameter);
    // console.log(`______________________`);
  };

  // On scroll change
  const onScroll = () => {
    //movLog('onScroll');
    moveableRef && moveableRef.current && moveableRef.current.updateRect();
    cropMoveableRef && cropMoveableRef.current && cropMoveableRef.current.updateRect();
  };

  // Check numbers for Persian digits
  const numbersCheck = target => {
    //movLog('numbersCheck / Check numbers for Persian digits');
    const e2p = s => s.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    const divs = target
      ? target.querySelectorAll('.public-DraftStyleDefault-rtl')
      : document.querySelectorAll('.public-DraftStyleDefault-rtl');
    divs.forEach(div => {
      const spans = div.querySelectorAll('span');
      spans.forEach(span => {
        if (span.dataset.text) {
          span.textContent = e2p(span.textContent);
        }
      });
    });
  };

  // Show Video controller
  const videoController = (page, target, targetId) => {
    //movLog('videoController / Show video controller');
    let activeControlTarget;
    const activeController = document.querySelector(`#selectoHolder .mainMoveable .controller`);
    if (activeController) {
      if (activeController.dataset.id !== `vc_${targetId}`) {
        activeController.style.display = 'none';
        activeControlTarget && activeControlTarget.appendChild(activeController);
      } else {
        videoControllerElements(page, target);
        return;
      }
    }
    activeControlTarget = target;
    const controller = target.querySelector('.controller');
    const container = document.querySelector(`#selectoHolder .mainMoveable`);
    if (controller) {
      container.appendChild(controller);
      videoControllerElements(target);
    }
  };

  //Set controller elements position
  const videoControllerElements = target => {
    //movLog('videoControllerElements / Set controller elements position', 'Target', target);
    try {
      let controller = document.querySelector(`#selectoHolder .mainMoveable .controller`);
      if (!controller) {
        return;
      }
      const designScale = document.querySelector('.artboard').style.transform.replace(/[ ,)(]|scale/g, ''); //props.designScale / 100;
      const targetScaleX = targetConfig.frame.scale[0];
      const targetScaleY = targetConfig.frame.scale[1];
      controller.style.display = 'block';
      const targetWidth = target.style.width ? parseFloat(target.style.width) : target.offsetWidth;
      const targetHeight = target.style.height ? parseFloat(target.style.height) : target.offsetHeight;
      controller.style.width = targetWidth * targetScaleX * designScale + 'px';
      controller.style.height = targetHeight * targetScaleY * designScale + 'px';
      const playBtn = controller.querySelector('.playBtn');
      playBtn.style.marginTop = ((targetHeight * targetScaleY) / 2 - 85) * designScale + 'px';
      playBtn.style.marginBottom = ((targetHeight * targetScaleY) / 2 - 170) * designScale + 'px';
      const slider = controller.querySelector('.input-range');
    } catch (error) { }
  };

  //Set video controller rotation
  const controllerUpdate = (target, opacity) => {
    //movLog('controllerUpdate / Set video controller rotation', 'target', target);
    //movLog('', 'opacity', opacity);
    const hasVideo = target.querySelector('video');
    //movLog('', 'hasVideo', hasVideo);
    if (hasVideo === null) return;
    const controller = document.getElementById(`vController`);
    const controlBox = document.querySelectorAll(`#selectoHolder .mainMoveable`)[0];
    const nwHandler = controlBox.querySelector('.moveable-nw');
    const rotateHandler = controlBox.querySelector('.moveable-rotation-line');
    if (!nwHandler || !controller || !rotateHandler) return;
    videoControllerElements(target);
    const tM = nwHandler.style.transform;
    controller.style.transform = `${tM}`;
    controller.style.opacity = opacity;
  };

  // Flip observer for crop
  const flipObserver = new MutationObserver(function (mutations) {
    //movLog('flipObserver');
    mutations.forEach(function (mutationRecord) {
      const moveableArea = document.querySelector('.moveable-area');
      const flip = mutationRecord.target.style.transform.replace(/[ ,.)(]|scale/g, '');
      if (moveableArea) moveableArea.className = `moveable-area flip${flip}`;
    });
  });

  // Observer for text box size changing
  const resizeObserver = new ResizeObserver(() => {
    // //movLog('Start Resize Observer');
    if (!_.get(targetConfig, 'onEdit', false)) return;
    const targetConf = targetConfig;
    if (!targetConf) return;
    if (targetConf.holderEl && targetConf.target) {
      if (targetConf.target.dataset.notFix === 'true') {
        const designScale = document.querySelector('.artboard').style.transform.replace(/[ ,)(]|scale/g, '');
        const widthLimit = artboarWidth * 1 * designScale;
      } else {
        targetConf.target.style.maxWidth = '';
      }
      const oldAPos = utils.cornerA(targetConf);
      const currentPos = utils.getTransform(targetConf.target, targetConf.holderEl);
      utils.entityNewPos(targetConf.target, targetConf.holderEl, oldAPos, currentPos, true);
      moveableRef.current && moveableRef.current.updateRect();
      //movLog('Start Get master & inner styles');
      const master = _.get(targetConfig, 'target') ? utils.css2js(targetConfig.target.style.cssText) : {};
      const inner = _.get(targetConfig, 'holder') ? utils.css2js(targetConfig.holderEl.style.cssText) : {};
      //movLog('', 'Master', master);
      //movLog('', 'Inner', inner);
      const changes = {
        id: targetConfig.id,
        type: targetConfig.type,
        masterStyle: master,
        innerStyle: inner,
      };
      //movLog('', 'Changes', changes);
      onEntityStyleChanged(changes);
    }
  });

  const deleteEntity = (id, type) => {
    if (_.get(selectedEntity, 'lock')) return;
    //movLog('Delete entity');
    if (type === 'Background') {
      dispatch(designActions.deletePageBackground(activePageRef.current));
    } else if (type === 'ImageBackground' || type === 'VideoBackground') {
      dispatch(designActions.deletePageBackground(activePageRef.current));
      dispatch(designActions.changeSelectedEntity({ id: `-${activePageRef.current}`, type: 'Background' }));
    } else {
      const deletedEntities = Array.isArray(id) ? id.map(String) : [id.toString()];
      if (type !== 'Frame' && !_.has(entitiesState[id], 'data.medias')) {
        deselectAll();
      }
      dispatch(designActions.deleteEntity(activePageRef.current, deletedEntities));
    }
  };

  const onMouseup = e => {
    //movLog('On mouseup', 'e', e);
    let clickedItem = e.target;
    while (!clickedItem.classList.contains('rSable')) {
      clickedItem = clickedItem.parentNode;
    }
    const selectedEntityId = selectedEntity
      ? selectedEntity.id || selectedEntity.id == 0
        ? `_${selectedEntity.id}_`
        : ''
      : '';
    if (selectedEntityId == clickedItem.id) return;
    // if (_.get(targetConfig, 'onEdit')) return;
    setTargetConfig(null);
    setTimeout(() => {
      selectEntities(null, clickedItem);
    });
  };
  const onKeyDown = e => {
    //movLog('On key down');
    if (_.get(targetConfig, 'onEdit')) return;
    // Block keys when entity selected
    switch (e.keyCode) {
      case 37: // Left arrow
      case 38: // Up arrow
      case 39: // Right arrow
      case 40: // Down arrow
        // case 32: // Space
        if (targetConfig) e.preventDefault();
        break;
      default:
        break; // do not block other keys
    }
    setTimeout(() => {
      const targetConf = targetConfig;
      if (targetConf) keyDown(e.keyCode, targetConf);
    });
  };

  const keyDown = (key, targetConf) => {
    //movLog('Key down', 'key', key);
    if (key === 46) {
      if (targetConf.editMode) return;
      if (Array.isArray(targetConf)) {
        const ids = [];
        targetConf.forEach(target => {
          ids.push(target.id);
        });
        deleteEntity(ids, 'Group');
      } else {
        deleteEntity(targetConf.id, targetConf.type);
      }
    }
    if (key === 16) {
      if (!keys.isShift) setKeys({ ...keys, isShift: true });
    }
    if (key === 17) {
      // if (!keys.isCtrl) setKeys({ ...keys, isCtrl: true });
    }

    if (targetConf && !targetConf.onEdit && targetConf.type !== 'Background') {
      if (key > 36 && key < 41) {
        let steps = 1;
        if (keys.isShift) steps = 10;
        clearTimeout(saveTimeout);
        switch (key) {
          case 37:
            // Left pressed
            stepMove(targetConf, steps, 'left');
            break;
          case 38:
            // Up pressed
            stepMove(targetConf, steps, 'up');
            break;
          case 39:
            // Right pressed
            stepMove(targetConf, steps, 'right');
            break;
          case 40:
            // Down pressed
            stepMove(targetConf, steps, 'down');
            break;
        }
        let changes = null;
        let data = null;
        if (targetConf.length > 1) {
          changes = [];
          targetConf.forEach((targetConf, index) => {
            const id = targetConf.id;
            let data = {
              masterStyle: utils.css2js(targetConf.target.style.cssText),
            };
            changes.push({ id: id, data: data });
          });
        } else {
          if (!targetConf.target) return;
          if (targetConf.holderEl && targetConf.type !== 'Text') {
            data = {
              masterStyle: utils.css2js(targetConf.target.style.cssText),
              innerStyle: utils.css2js(targetConf.holderEl.style.cssText),
            };
          } else {
            data = {
              masterStyle: utils.css2js(targetConf.target.style.cssText),
            };
          }
          changes = {
            ...data,
            id: targetConf.id,
            type: targetConf.type,
            // targetId: targetConf.targetId,
          };
        }
        saveTimeout = setTimeout(() => {
          targetConfig.save = true;
          onEntityStyleChanged(changes);
        }, 1500);
      }
    }
  };

  const onKeyUp = e => {
    //movLog('On key up');
    if (_.get(targetConfig, 'onEdit')) return;
    if (e.keyCode === 16) {
      const moveableArea = document.querySelectorAll('.moveable-area');
      if (moveableArea[0]) moveableArea[0].style.display = '';
      if (moveableArea[1]) moveableArea[1].style.display = '';

      setKeys({ ...keys, isShift: false });
    }
    if (e.keyCode === 17) {
      // setKeys({ ...keys, isCtrl: false });
    }
  };

  const stepMove = (targets, steps, direction) => {
    if (_.get(selectedEntity, 'lock')) return;
    //movLog('Step move by arrow keys');
    let targetArray = true;
    if (!Array.isArray(targets)) {
      targetArray = false;
      targets = [targets];
    }
    targets.forEach((target, index) => {
      switch (direction) {
        case 'left':
          if (targetArray) targetConfig[index].frame.translate[0] -= steps;
          else targetConfig.frame.translate[0] -= steps;
          break;
        case 'up':
          if (targetArray) targetConfig[index].frame.translate[1] -= steps;
          else targetConfig.frame.translate[1] -= steps;
          break;
        case 'right':
          if (targetArray) targetConfig[index].frame.translate[0] += steps;
          else targetConfig.frame.translate[0] += steps;
          break;
        case 'down':
          if (targetArray) targetConfig[index].frame.translate[1] += steps;
          else targetConfig.frame.translate[1] += steps;
          break;
      }
      if (targetArray)
        targetConfig[
          index
        ].target.style.transform = `translateX(${targetConfig[index].frame.translate[0]}px) translateY(${targetConfig[index].frame.translate[1]}px)  rotate(${targetConfig[index].frame.rotate}deg)  scaleX(${targetConfig[index].frame.scale[0]}) scaleY(${targetConfig[index].frame.scale[1]})`;
      else
        targetConfig.target.style.transform = `translateX(${targetConfig.frame.translate[0]}px) translateY(${targetConfig.frame.translate[1]}px)  rotate(${targetConfig.frame.rotate}deg)  scaleX(${targetConfig.frame.scale[0]}) scaleY(${targetConfig.frame.scale[1]})`;
    });
    moveableRef && moveableRef.current && moveableRef.current.updateRect();
  };

  const deselectAll = () => {
    //movLog('Deselect All');
    setTargets(null);
    setTargetConfig(null);
    //movLog('', 'on Select Entity 4');
    onSelectEntity(null);
    showColorPicker(false);
    showFilterPanel(false);
    resizeObserver.disconnect();
    enableEditor(-1);
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }
    changeEditableMode(null, false);
  };

  const onSelectEntity = entity => {
    //movLog('onSelectEntity', 'entity', entity);
    //movLog('', 'targetConfig', targetConfig);
    showFilterPanel(false);
    showColorPicker(false);
    if (entity && entity.type === 'Background') {
      entity.id = `-${activePageRef.current}`;
      entity.lock = _.get(pages[activePageRef.current], 'background.lock', false);
      if (_.get(targetConfig, 'mediaBackground')) {
        entity.type = `${targetConfig.mediaBackground}Background`;
      }
    }
    dispatch(designActions.changeSelectedEntity(entity));
    if (mobile && _.get(targetConfig, 'onEdit')) {
      //movLog('', 'try remove mouseup', targetConfig.target);
      setTimeout(() => {
        targetConfig.target.removeEventListener('mouseup', onMouseup, true);
      });
    }
  };

  const updateGroupTargetConfig = () => {
    //movLog('updateGroupTargetConfig', 'targetConfig', targetConfig);
    targetConfig.forEach((target, i) => {
      const transform = utils.getTransform(target.target, target.holderEl);
      targetConfig[i].frame.translate = [transform.tx, transform.ty];
      targetConfig[i].frame.scale = [transform.sx, transform.sy];
      targetConfig[i].frame.w = transform.w;
      targetConfig[i].frame.h = transform.h;
    });
  };

  const updateTargetConfig = () => {
    //movLog('update TargetConfig');
    if (selectedEntity) {
      const target = targetConfig.target;
      const holder = targetConfig.holderEl;
      const transform = utils.getTransform(target, holder);
      const newConfig = {
        ...targetConfig,
        target: target,
        frame: {
          translate: [transform.tx, transform.ty],
          scale: [transform.sx, transform.sy],
          transformOrigin: '50% 50%',
          rotate: transform.rotate,
          clipStyle: 'inset',
          flip: transform.flip,
          w: target.offsetWidth,
          h: target.offsetHeight,
        },
        holderEl: holder,
        holder: transform.holder,
        page: activePageRef.current,
      };
      // if (!_.isEqual(targetConfig, newConfig))
      setTargetConfig(newConfig);
    } else {
      setTargetConfig(null);
    }
  };

  const allEqual = arr => arr.every(v => v === arr[0]);

  const textEditTool = () => {
    const confirm = () => {
      document.getElementById('textEditToolbar').remove();
      enableEditor(null);
      dispatch(designActions.changeEditableMode({ id: targetConfig.id, editable: false }));
      setTargetConfig({ ...targetConfig, onEdit: null, editMode: null });
      setTimeout(() => {
        // selectEntities(null, targetConfig.target);
      });
    };
    const toolbar = document.createElement('div');
    const confirmBtn = document.createElement('span');
    confirmBtn.classList.add('confirm');
    confirmBtn.addEventListener('mousedown', confirm);
    // confirmBtn.innerHTML = `Confirm`;
    toolbar.append(confirmBtn);
    toolbar.id = 'textEditToolbar';
    return toolbar;
  };
  //`<div className="textEditTool">This is text edit toolbar</div>`;

  const dblClickHandler = e => {
    //movLog('dblClickHandler', 'e', e);
    if (_.get(selectedEntity, 'lock') && targetConfig.type !== 'Background') return;
    //movLog('dblClickHandler', 'targetConfig', targetConfig);
    if (targetConfig.onEdit) return;
    switch (targetConfig.type) {
      case 'Text':
        // targetConfig.target.removeEventListener('mouseup', onMouseup);
        if (mobile) {
          // ReactDOM.render(textEditTool(), document.getElementById('GBEditor'));
          document.getElementById('GBEditor').append(textEditTool());
        }
        setTimeout(() => {
          enableEditor(targetConfig.id);
        });
        setTargetConfig({
          ...targetConfig,
          onEdit: true,
          changedParent: true,
          editMode: 'typing',
        });
        break;
      case 'Image':
        setTargetConfig({
          ...targetConfig,
          onEdit: true,
          changedParent: false,
          editMode: 'crop',
        });
        break;
      case 'Grid':
        // return;
        // eslint-disable-next-line no-case-declarations
        let gridItem = e.target;
        if (e.target.tagName == 'IMG') {
          while (!gridItem.className.includes('gridItem')) {
            gridItem = gridItem.parentNode;
          }
        }
        // eslint-disable-next-line no-case-declarations
        const cropTarget = document.getElementById(`E${targetConfig.id}_${gridItem.style.gridArea}`);
        // eslint-disable-next-line no-case-declarations
        const cropTransform = utils.getTransform(gridItem, cropTarget);
        //movLog('Grid CropMode', 'cropTransform', cropTransform);
        setTargetConfig({
          ...targetConfig,
          onEdit: true,
          changedParent: false,
          editMode: 'crop',
          holderEl: cropTarget,
          holder: cropTransform.holder,
        });
        break;
      case 'Background':
        if (_.get(pages[targetConfig.page], 'background.lock')) return;
        setTargetConfig({
          ...targetConfig,
          onEdit: true,
          changedParent: false,
          editMode: 'crop',
        });
        break;
      case 'Frame':
        setTargetConfig({
          ...targetConfig,
          onEdit: true,
          changedParent: false,
          editMode: 'crop',
        });
        break;
      default:
        break;
    }
  };

  const selectEntities = (e, entity) => {
    //movLog('Start selectEntities');
    const groupName = _.has(e, 'selected[0]') ? e.selected[0].dataset.group : '';

    // Set Elements for Guideline
    // console.log('Active Page = ', activePageRef.current);
    setElementGuidelines([...document.querySelectorAll(`#artboardContainer_${activePageRef.current} .moveable`)]);
    // ./Set Elements for Guideline

    let groupedEntities;
    if (groupName) {
      const groupParent = document.getElementById(`_${groupName}_`);
      groupedEntities = groupParent.querySelectorAll(`[data-group=${groupName}]`);
    }
    const targetsConfig = [];
    const entities = groupedEntities ? groupedEntities : e ? e.selected : [entity];
    let firstPage;

    if (entities.length === 0) {
      deselectAll();
      return;
    }
    let multiTargets = false;
    if (entities.length > 1) multiTargets = true;
    entities.forEach(target => {
      let targetId = false;
      if (multiTargets && target.dataset.type !== 'background') {
        if (target.dataset.lock !== 'true') {
          if (firstPage !== target.dataset.page) {
            if (!firstPage) {
              firstPage = target.dataset.page;
              targetId = target && target.dataset.target;
            }
          } else {
            targetId = target && target.dataset.target;
          }
        }
      } else if (!multiTargets) {
        targetId = target && target.dataset.target;
      }

      if (targetId && targetId !== _.get(targetConfig, 'targetId')) {
        const typeConfig = utils.convertId(targetId);
        const holder = document.getElementById(`E${targetId}`);
        let mediaBackground = '';
        const entityId = _.get(typeConfig, 'type') === 'Background' ? -1 : _.get(typeConfig, 'id');
        if (typeConfig.type === 'Background' && holder) {
          mediaBackground = holder.getAttribute('type');
        }
        const transform = utils.getTransform(target, holder);
        dispatch(designActions.changeEditableMode({ id: entityId, editable: false }));
        targetsConfig.push({
          id: entityId,
          type: typeConfig.type,
          targetId: typeConfig.targetId,
          target: target,
          flip: transform.flip,
          frame: {
            translate: [transform.tx, transform.ty],
            scale: [transform.sx, transform.sy],
            transformOrigin: '50% 50%',
            rotate: transform.rotate,
            clipStyle: 'inset',
            w: transform.w,
            h: transform.h,
          },
          directions: typeConfig.renderDir,
          ables: typeConfig.moveableConfig,
          holderEl: holder,
          holder: transform.holder,
          mediaBackground: mediaBackground,
          page: activePageRef.current,
        });
      }
    });
    if (targetsConfig.length > 1) {
      setTargetConfig(targetsConfig);
    } else if (entities.length !== 0) {
      if (editableTextId === -1) {
        setTargetConfig(targetsConfig[0]);
      } else {
        setTargetConfig({
          ...targetsConfig[0],
          onEdit: true,
          changedParent: true,
          editMode: 'typing',
        });
      }
    }
    //moveable start drag
    const moveable = moveableRef.current;
    if (e && e.isDragStart) {
      e.inputEvent.preventDefault();
      moveable.dragStart(e.inputEvent);
    }
  };

  // Change element parent for edit mode outside moveable target
  const changeParent = () => {
    const changeTarget = targetConfig;
    //movLog('Start ChangeParent', 'changeTarget', changeTarget);
    if (!changeTarget) return;
    if (changeTarget && (_.get(changeTarget, 'type') !== 'Text' || !_.get(changeTarget, 'holderEl'))) return;
    // check and set for fix width
    const targetWidth = _.get(changeTarget.target, 'style.width');
    if (!targetWidth) {
      changeTarget.target.dataset.notFix = 'true';
    }
    // Set Moveable target styles to change element
    changeTarget.holderEl.style.transform = changeTarget.target.style.transform;
    changeTarget.holderEl.style.width = changeTarget.target.style.width;
    changeTarget.target.style.width = changeTarget.holderEl.offsetWidth + 'px';
    changeTarget.target.style.height = changeTarget.holderEl.offsetHeight + 'px';

    // Change HolderEl parent to artboard container
    const activePage = changeTarget.page ? changeTarget.page : activePageRef.current;
    let editableBox = document.getElementById(`artboardContainer_${activePage}`);
    editableBox.appendChild(changeTarget.holderEl);

    document.getElementById('artboardHolder').classList.add('onEdit');
    targetConfig.target.classList.add('onEdit');
    resizeObserver.observe(changeTarget.holderEl);
    targetConfig.target.removeEventListener('dblclick', dblClickHandler);
  };

  // Reverse changeParent function
  const changeReverse = () => {
    if (!targetConfig || (targetConfig && !targetConfig.changedParent)) return;
    //movLog('Start changeReverse');
    resizeObserver.disconnect();
    enableEditor(-1);
    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }
    document.getElementById('artboardHolder').classList.remove('onEdit');
    targetConfig.holderEl.style.cssText = '';
    targetConfig.target.appendChild(targetConfig.holderEl);
    targetConfig.target.style.height = '';
    if (targetConfig.target.dataset.notFix === 'true') {
      targetConfig.target.style.width = '';
    }
    if (targetConfig && targetConfig.editMode) targetConfig.editMode = false;
  };

  const SelectoC = () => {
    return (
      <>
        {!mobile && (
          <Selecto
            ref={selectoRef}
            container={'#rectSelectHolder'} //{`#artboardContainer_${activePageRef.current}`}
            dragContainer={'#rectSelectHolder'}
            selectableTargets={[`.rSable`]}
            hitRate={0}
            ratio={0}
            selectByClick={true}
            selectFromInside={_.get(targetConfig, 'ables.selectFromInside', false)}
            toggleContinueSelect={['shift']}
            // continueSelect={keys.isShift}
            // preventDefault={false}
            onDragStart={e => {
              //movLog('Selecto onDragStart');
              const moveable = moveableRef.current;
              const target = e.inputEvent.target;
              //movLog('', 'e', e);
              if (_.get(targetConfig, 'editMode') === 'typing' && _.get(target, 'dataset.text')) e.stop();
              if (
                moveable.isMoveableElement(target) ||
                (targets && Array.isArray(targets) && targets.some(t => t === target || t.contains(target)))
              ) {
                e.stop();
              }
            }}
            onSelect={e => {
              const selectedTargets = [];
              const selectedTargetsId = [];
              let multiPageSelect = false;
              let firstPage;

              e.selected.forEach(selectedTarget => {
                if (selectedTarget.dataset.type !== 'background') {
                  if (firstPage !== selectedTarget.dataset.page) {
                    if (!firstPage) {
                      firstPage = selectedTarget.dataset.page;
                      selectedTargets.push(selectedTarget);
                    }
                  } else {
                    selectedTargets.push(selectedTarget);
                  }
                } else if (e.selected.length === 1) {
                  selectedTargets.push(selectedTarget);
                }
              });
              setTargets(selectedTargets);
              setTargetConfig(null);
            }}
            onSelectEnd={e => {
              //movLog('Selecto onSelectEnd');
              if (e.selected.length !== 0 || (e.selected.length === 0 && targets)) selectEntities(e, null);
            }}
          />
        )}
        {/* Crop Moveable component */}
        <Moveable
          ref={cropMoveableRef}
          target={_.get(cropTarget, 'target')}
          className={'cropMoveable'}
          draggable={true}
          resizable={true}
          scalable={false}
          rotatable={true}
          pinchable={true}
          rotationPosition={_.get(targetConfig, 'rotateHandler', 'top')}
          keepRatio={true}
          throttleScale={0}
          renderDirections={['nw', 'ne', 'sw', 'se']}
          snappable={true}
          edge={false}
          zoom={1}
          origin={false}
          padding={{ left: 0, top: 0, right: 0, bottom: 0 }}
          dragArea={true}
          onDragStart={({ set }) => {
            set([targetConfig.holder.tx, targetConfig.holder.ty]);
          }}
          onDrag={({ beforeTranslate }) => {
            //movLog('Crop on drag');
            //movLog('', 'targetConfig', targetConfig);
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.save = true;
            if (targetConfig.flip && targetConfig.flip[0] == -1) {
              if (targetConfig.type !== 'Grid' && beforeTranslate[0] > 0) {
                targetConfig.holder.tx = 0;
              } else if (
                targetConfig.type !== 'Grid' &&
                beforeTranslate[0] / targetConfig.holder.sx < -(targetConfig.holder.w - targetConfig.frame.w)
              ) {
                targetConfig.holder.tx = -(targetConfig.holder.w - targetConfig.frame.w);
              } else {
                targetConfig.holder.tx = beforeTranslate[0];
              }
            } else {
              if (targetConfig.type !== 'Grid' && beforeTranslate[0] > 0) {
                targetConfig.holder.tx = 0;
              } else if (
                targetConfig.type !== 'Grid' &&
                beforeTranslate[0] / targetConfig.holder.sx < -(targetConfig.holder.w - targetConfig.frame.w)
              ) {
                targetConfig.holder.tx = -(targetConfig.holder.w - targetConfig.frame.w);
              } else {
                targetConfig.holder.tx = beforeTranslate[0];
              }
            }
            if (targetConfig.flip && targetConfig.flip[1] == -1) {
              if (targetConfig.type !== 'Grid' && beforeTranslate[1] > 0) {
                targetConfig.holder.ty = 0;
              } else if (
                targetConfig.type !== 'Grid' &&
                beforeTranslate[1] < -(targetConfig.holder.h - targetConfig.frame.h)
              ) {
                targetConfig.holder.ty = -(targetConfig.holder.h - targetConfig.frame.h);
              } else {
                targetConfig.holder.ty = beforeTranslate[1];
              }
            } else {
              if (targetConfig.type !== 'Grid' && beforeTranslate[1] > 0) {
                targetConfig.holder.ty = 0;
              } else if (
                targetConfig.type !== 'Grid' &&
                beforeTranslate[1] < -(targetConfig.holder.h - targetConfig.frame.h)
              ) {
                targetConfig.holder.ty = -(targetConfig.holder.h - targetConfig.frame.h);
              } else {
                targetConfig.holder.ty = beforeTranslate[1];
              }
            }
          }}
          onRotateStart={({ set }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            set(targetConfig.holder.rotate);
          }}
          onRotate={({ beforeRotate }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.save = true;
            targetConfig.holder.rotate = beforeRotate;
          }}
          onResizeStart={({ setOrigin, dragStart }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            setOrigin(['%', '%']);
            dragStart && dragStart.set([targetConfig.holder.tx, targetConfig.holder.ty]);
          }}
          onResize={({ target, width, height, drag }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.save = true;
            const beforeTranslate = drag.beforeTranslate;
            if (beforeTranslate[0] > 0) return;
            if ((width / height).toFixed(2) !== targetConfig.holder.ratio.toFixed(2)) {
              targetConfig.holder.w = height * targetConfig.holder.ratio;
              targetConfig.holder.h = height;
              target.style.width = `${height * targetConfig.holder.ratio}px`;
              target.style.height = `${height}px`;
            } else {
              targetConfig.holder.w = width;
              targetConfig.holder.h = height;
              target.style.width = `${width}px`;
              target.style.height = `${height}px`;
            }
            targetConfig.holder.tx = beforeTranslate[0];
            targetConfig.holder.ty = beforeTranslate[1];
          }}
          onRenderStart={({ target }) => {
            target.style.minWidth = targetConfig.holder.w + targetConfig.holder.tx + 'px';
            target.style.minHeight = targetConfig.holder.h + targetConfig.holder.ty + 'px';
          }}
          onRender={({ target }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            const { tx, ty, rotate, sx, sy } = targetConfig.holder;
            target.style.transform = `translateX(${tx}px) translateY(${ty}px)  rotate(${rotate}deg)  scaleX(${sx}) scaleY(${sy})`;
            target.style.minWidth = targetConfig.holder.w + targetConfig.holder.tx + 'px';
            target.style.minHeight = targetConfig.holder.h + targetConfig.holder.ty + 'px';
          }}
          onRenderEnd={({ target }) => {
            target.style.minWidth = '';
            target.style.minHeight = '';
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            const master = _.get(targetConfig, 'target') ? utils.css2js(targetConfig.target.style.cssText) : {};
            const inner = _.get(targetConfig, 'holder') ? utils.css2js(targetConfig.holderEl.style.cssText) : {};
            const changes = {
              id: targetConfig.id,
              type: targetConfig.type,
              masterStyle: master,
              innerStyle: inner,
            };
            if (targetConfig.type !== 'Grid') {
              onEntityStyleChanged(changes);
            } else if (targetConfig.type === 'Grid') {
              const area = _.get(targetConfig, 'target') && targetConfig.holderEl.id.split('_')[1];
              const areaStyle = _.get(targetConfig, 'target') ? utils.css2js(targetConfig.holderEl.style.cssText) : {};
              //movLog('Start save Grid area style', 'area', area);
              //movLog('', 'areaStyle', areaStyle);
              const areaChange = {
                id: targetConfig.id,
                type: targetConfig.type,
                data: {
                  area: area,
                  medias: {
                    [area]: { style: { inner: areaStyle } },
                  },
                },
              };
              onEntityStyleChanged(areaChange);
            }
            //movLog('Crop Moveable', 'Change to bottom', target.getBoundingClientRect().top);
            if (target.getBoundingClientRect().top < 150) {
              setTargetConfig({ ...targetConfig, rotateHandler: 'bottom' });
            } else {
              setTargetConfig({ ...targetConfig, rotateHandler: 'top' });
            }
          }}
        />
        {/* Main Moveable component */}
        <Moveable
          ref={moveableRef}
          target={targets}
          className={`mainMoveable ${_.get(selectedEntity, 'lock') ? 'locked' : ''}`}
          draggable={
            (targets && _.get(targets[0], 'dataset.lock')) === 'true' ||
              _.get(selectedEntity, 'lock') ||
              _.get(targetConfig, 'editMode') === 'typing'
              ? false
              : _.get(targetConfig, 'ables.isDraggable', true)
          }
          defaultGroupOrigin={'50% 50%'}
          // transformOrigin={'50% 50%'}
          originRelative={false}
          originDraggable={false}
          origin={false}
          pinchable={true}
          // Guidelines
          elementGuidelines={elementGuidelines}
          snappable={true}
          verticalGuidelines={[0, 200, 400]}
          horizontalGuidelines={[0, 200, 400]}
          snapThreshold={5}
          isDisplaySnapDigit={true}
          snapGap={true}
          snapElement={true}
          snapVertical={true}
          snapHorizontal={true}
          snapCenter={false}
          snapDigit={0}
          // ./Guidelines
          resizable={_.get(targetConfig, 'ables.isResizable', false)}
          scalable={_.get(targetConfig, 'ables.isScalable', true)}
          rotatable={!_.get(selectedEntity, 'lock') ? _.get(targetConfig, 'ables.isRotatable', true) : false}
          rotationPosition={'top'}
          keepRatio={isShift}
          renderDirections={
            !_.get(selectedEntity, 'lock') ? _.get(targetConfig, 'directions', ['nw', 'ne', 'se', 'sw']) : []
          }
          edge={false}
          zoom={1}
          padding={
            _.get(targetConfig, 'type') === 'Text'
              ? { left: 0, top: 0, right: 0, bottom: 0 }
              : { left: 0, top: 0, right: 0, bottom: 0 }
          }
          onClickGroup={e => {
            selectoRef.current.clickTarget(e.inputEvent, e.inputTarget);
          }}
          onDragOriginStart={({ dragStart }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            dragStart && dragStart.set(targetConfig.frame.translate);
          }}
          onDragOrigin={({ drag, transformOrigin }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.frame.translate = drag.beforeTranslate;
            targetConfig.frame.transformOrigin = transformOrigin;
          }}
          onDragStart={({ target, set }) => {
            //movLog('Main moveable onDragStart');
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            const transform = utils.getTransform(target);
            targetConfig.frame.scale = [transform.sx, transform.sy];
            set([transform.tx, transform.ty]);
          }}
          onDrag={({ target, beforeTranslate }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            if (
              _.get(selectedEntity, 'lock') ||
              _.get(target, 'dataset.lock') === 'true' ||
              _.get(targetConfig, 'editMode') === 'typing'
            )
              return;
            targetConfig.save = true;
            targetConfig.frame.translate = [beforeTranslate[0], beforeTranslate[1]];
          }}
          onRotateStart={({ set }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            set(targetConfig.frame.rotate);
          }}
          onRotate={({ beforeRotate }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.save = true;
            targetConfig.frame.rotate = beforeRotate;
          }}
          onResizeStart={({ setOrigin, dragStart, direction, target }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            if (targetConfig && targetConfig.holder) {
              setLastPos({
                rx: targetConfig.frame.translate[0],
                ry: targetConfig.frame.translate[1],
                x: targetConfig.holder.tx,
                y: targetConfig.holder.ty,
                w: targetConfig.target.offsetWidth,
                h: targetConfig.target.offsetHeight,
              });
            }
            setOrigin(['%', '%']);
            const flipper = target.querySelector('.flipper');
            const flipStyle = _.get(flipper, 'style.transform');
            let flip = [1];
            if (flipStyle) flip = flipStyle.replace(/[ .)(]|scale/g, '').split(',');
            if (flip.length === 1) {
              flip.push(flip[0]);
            }
            targetConfig.frame.flip = flip;
            dragStart && dragStart.set(targetConfig.frame.translate);
          }}
          onResize={({ target, width, height, drag, direction }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.save = true;
            if (direction[0] !== 0 && direction[1] !== 0) {
              setIsShift(true);
            } else {
              setIsShift(false);
            }
            const beforeTranslate = drag.beforeTranslate;

            targetConfig.frame.translate = beforeTranslate;
            target.style.width = `${width}px`;
            target.style.height = `${height}px`;

            if (targetConfig.type === 'Image') {
              const imgCropTX =
                targetConfig.frame.flip[0] == 1
                  ? drag.beforeTranslate[0] - lastPos.rx - lastPos.x
                  : lastPos.w - width - lastPos.x;
              const imgCropTY =
                targetConfig.frame.flip[1] == 1
                  ? drag.beforeTranslate[1] - lastPos.ry - lastPos.y
                  : lastPos.h - height - lastPos.y;
              const handler = [direction[0] * targetConfig.frame.flip[0], direction[1] * targetConfig.frame.flip[1]];
              switch (handler.toString()) {
                // Direction W
                case '-1,0':
                  //movLog('', 'Direction W');
                  targetConfig.holderEl.style.transform = `translateX(${-imgCropTX}px) translateY(${lastPos.y
                    }px) scaleX(${targetConfig.holder.sx}) scaleY(${targetConfig.holder.sy}) rotate(${targetConfig.holder.rotate
                    }deg)`;
                  if (imgCropTX < 0) {
                    targetConfig.holderEl.style.transform = `translateX(0px) translateY(${lastPos.y}px)`;
                    targetConfig.holderEl.style.width = `${targetConfig.holder.w + -imgCropTX}px`;
                  }

                  break;
                // Direction N
                case '0,-1':
                  targetConfig.holderEl.style.transform = `translateX(${lastPos.x
                    }px) translateY(${-imgCropTY}px) scaleX(${targetConfig.holder.sx}) scaleY(${targetConfig.holder.sy
                    }) rotate(${targetConfig.holder.rotate}deg)`;
                  if (imgCropTY < 0) {
                    targetConfig.holderEl.style.transform = `translateX(${lastPos.x}px) translateY(0px)`;
                    targetConfig.holderEl.style.height = `${targetConfig.holder.h + -imgCropTY}px`;
                    targetConfig.holderEl.style.width = `${targetConfig.holder.h * targetConfig.holder.ratio}px`;
                  }
                  break;
                // Direction E
                case '1,0':
                  //movLog('', 'Direction E');
                  if (width > targetConfig.holder.w + lastPos.x) {
                    let newWidth = targetConfig.holder.w * (width / (targetConfig.holder.w + lastPos.x));
                    let newTX = (newWidth * lastPos.x) / targetConfig.holder.w;
                    targetConfig.holderEl.style.transform = `translateX(${newTX}px) translateY(${lastPos.y}px) scaleX(${targetConfig.holder.sx}) scaleY(${targetConfig.holder.sy}) rotate(${targetConfig.holder.rotate}deg)`;
                    targetConfig.holderEl.style.width = `${newWidth}px`;
                    targetConfig.holderEl.style.height = `${newWidth / targetConfig.holder.ratio}px`;
                  }
                  break;
                // Direction S
                case '0,1':
                  if (height > targetConfig.holder.h + lastPos.y) {
                    let newHeight = targetConfig.holder.h * (height / (targetConfig.holder.h + lastPos.y));
                    let newTY = (newHeight * lastPos.y) / targetConfig.holder.h;
                    targetConfig.holderEl.style.transform = `translateX(${lastPos.x}px) translateY(${newTY}px) scaleX(${targetConfig.holder.sx}) scaleY(${targetConfig.holder.sy}) rotate(${targetConfig.holder.rotate}deg)`;
                    targetConfig.holderEl.style.height = `${newHeight}px`;
                    targetConfig.holderEl.style.width = `${newHeight * targetConfig.holder.ratio}px`;
                  }
                  break;
                default:
                  // eslint-disable-next-line no-case-declarations
                  let newWidth = targetConfig.holder.w * (width / lastPos.w);
                  // eslint-disable-next-line no-case-declarations
                  let newHeight = targetConfig.holder.h * (height / lastPos.h);
                  // eslint-disable-next-line no-case-declarations
                  let newTX = (newWidth * lastPos.x) / targetConfig.holder.w;
                  // eslint-disable-next-line no-case-declarations
                  let newTY = (newHeight * lastPos.y) / targetConfig.holder.h;
                  targetConfig.holderEl.style.transform = `translateX(${newTX}px) translateY(${newTY}px)`;
                  targetConfig.holderEl.style.width = `${newWidth}px`;
                  targetConfig.holderEl.style.height = `${newWidth / targetConfig.holder.ratio}px`;
              }
            }
          }}
          onScaleStart={({ set, dragStart, direction, target }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            const transform = utils.getTransform(target);
            setIsShift(true);
            if (direction[0] === 0 || direction[1] === 0) {
              if (targetConfig.type === 'Text') {
                setLastPos({
                  rx: targetConfig.frame.translate[0],
                  ry: targetConfig.frame.translate[1],
                  scale: targetConfig.frame.scale,
                  x: targetConfig.holder.tx,
                  y: targetConfig.holder.ty,
                  w: parseInt(targetConfig.target.offsetWidth) / targetConfig.frame.scale[0],
                  h: targetConfig.target.offsetHeight,
                });
                document.getElementById('artboardHolder').classList.add('onTransform');
                targetConfig.target.style.border = 'calc(1 * var(--zoompx)) solid #4af';
              }
            }
            set([transform.sx, transform.sy]);
            dragStart && dragStart.set([transform.tx, transform.ty, transform.tz]);
          }}
          onScale={({ scale, drag, direction, target }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            if (target.offsetWidth * scale[0] < 20 || target.offsetHeight * scale[1] < 20) return;
            targetConfig.save = true;
            const beforeTranslate = drag.beforeTranslate;
            if (direction[0] !== 0 && direction[1] !== 0) {
              setIsShift(true);
              targetConfig.frame.translate = beforeTranslate;
              targetConfig.frame.scale = [scale[0], scale[1]];
            } else {
              setIsShift(false);
              if (targetConfig.type === 'Text') {
                target.dataset.notFix = 'false';
                const newWidth = lastPos.w * scale[0];
                target.style.width = newWidth + 'px';
                target.style.height = targetConfig.holderEl.offsetHeight + 'px';
                targetConfig.frame.translate = [beforeTranslate[0], beforeTranslate[1]];
              } else {
                targetConfig.frame.translate = beforeTranslate;
                targetConfig.frame.scale = [scale[0], scale[1]];
              }
            }
          }}
          onRenderStart={({ target }) => {
            //movLog('on render start');
            controllerUpdate(target, 0);
          }}
          onRender={({ target }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            const { translate, rotate, transformOrigin, scale } = targetConfig.frame;
            target.style.transformOrigin = transformOrigin;
            target.style.transform = `translateX(${translate[0]}px) translateY(${translate[1]}px)  rotate(${rotate}deg)  scaleX(${scale[0]}) scaleY(${scale[1]})`;
            if (targetConfig.editMode === 'crop') {
              cropMoveableRef.current && cropMoveableRef.current.updateRect();
            }
          }}
          onRenderEnd={() => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            if (targetConfig.type === 'Image' || targetConfig.type === 'Frame') {
              controllerUpdate(targetConfig.target, 1);
            }
            if (targetConfig.type === 'Text') {
              targetConfig.target.style.height = '';
            }
            document.getElementById('artboardHolder').classList.remove('onTransform');
            targetConfig.target.style.border = '';
            if (targetConfig.type === 'Image') updateTargetConfig();
            const master = _.get(targetConfig, 'target') ? utils.css2js(targetConfig.target.style.cssText) : {};
            const inner = _.get(targetConfig, 'holder') ? utils.css2js(targetConfig.holderEl.style.cssText) : {};
            const changes = {
              id: targetConfig.id,
              type: targetConfig.type,
              masterStyle: master,
              innerStyle: inner,
            };
            onEntityStyleChanged(changes);
          }}
          //*  Group actions *//
          onDragGroupStart={({ events }) => {
            //movLog('Start onDragGroupStart');
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            events.forEach((ev, i) => {
              //movLog('', 'ev', ev);
              if (targetConfig) {
                ev.set(targetConfig[i].frame.translate);
              } else {
                const transform = utils.getTransform(ev.target);
                ev.set([transform.tx, transform.ty]);
              }
            });
          }}
          onDragGroup={({ events }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            events.forEach((ev, i) => {
              targetConfig[i].frame.translate = ev.beforeTranslate;
            });
          }}
          onRotateGroupStart={({ events }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            events.forEach((ev, i) => {
              ev.set(targetConfig[i].frame.rotate);
              ev.dragStart && ev.dragStart.set(targetConfig[i].frame.translate);
            });
          }}
          onRotateGroup={({ events }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            events.forEach((ev, i) => {
              targetConfig[i].frame.translate = ev.drag.beforeTranslate;
              targetConfig[i].frame.rotate = ev.rotate;
            });
          }}
          onScaleGroupStart={({ events }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            events.forEach((ev, i) => {
              ev.set(targetConfig[i].frame.scale);
              ev.dragStart && ev.dragStart.set(targetConfig[i].frame.translate);
            });
          }}
          onScaleGroup={({ events }) => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            events.forEach((ev, i) => {
              targetConfig[i].frame.translate = ev.drag.beforeTranslate;
              targetConfig[i].frame.scale = ev.scale;
            });
          }}
          onRenderGroup={() => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            targetConfig.forEach((ev, i) => {
              const { translate, rotate, scale } = targetConfig[i].frame;
              targetConfig[
                i
              ].target.style.transform = `translateX(${translate[0]}px) translateY(${translate[1]}px)  rotate(${rotate}deg)  scaleX(${scale[0]}) scaleY(${scale[1]})`;
            });
          }}
          onRenderGroupEnd={() => {
            if (!targetConfig) {
              console.warn('Config not defined');
              return;
            }
            const changes = [];
            targetConfig.forEach((ev, i) => {
              const master = _.get(targetConfig[i], 'target') ? utils.css2js(targetConfig[i].target.style.cssText) : '';
              changes.push({ id: targetConfig[i].id, data: { master: master } });
            });
            onEntityStyleChanged(changes);
          }}
        />
      </>
    );
  };

  const isTouchDevice = () => {
    //movLog('isTouchDevice');
    return !!(
      ('ontouchstart' in window || navigator.maxTouchPoints) // works on most browsers
    ); // works on IE10/11 and Surface
  };
};

VMoveable.propTypes = {
  designScale: PropTypes.any,
  page: PropTypes.any,
  children: PropTypes.any,
  artboardSize: PropTypes.any,
};

export default React.memo(VMoveable);
// export default VMoveable;
